module.exports = __webpack_public_path__ + "img/metaverse-3.aa86cd36.png";